export var isTestingJest = process.env.NODE_ENV === 'test' || typeof jest !== 'undefined';